export default {
  fetchingKeyword: (state, keyword) => (state.fetchingKeywords.push(keyword)),
  fetchingKeywordResults: (state, keyword) => (state.fetchingKeywordResults.push(keyword)),
  fetchingKeywordSuccess: (state, keyword) => (state.fetchingKeywords = state.fetchingKeywords.filter(k => k !== keyword)),
  fetchingKeywordResultsSuccess: (state, keyword) => (state.fetchingKeywordResults = state.fetchingKeywordResults.filter(k => k !== keyword)),
  fetchingAdditionalResult: (state, uuid) => (state.fetchingAdditionalResults.push(uuid)),
  fetchingAdditionalResultError: (state, uuid) => (state.additionalResultErrors.push(uuid)),
  removeAdditionalResultFetchingStatus: (state, keyword) => (state.fetchingAdditionalResults = state.fetchingAdditionalResults.filter(k => k !== keyword)),
  removeAdditionalResultErrorStatus: (state, uuid) => (state.additionalResultErrors = state.additionalResultErrors.filter(k => k !== uuid)),
  updateSelectedKeyword: (state, value) => (state.selectedKeyword = value),
  updateKeywords: (state, payload) => (state.keywords = { ...state.keywords, ...payload }),
  updateKeyword: (state, payload) => (state.keywords = { ...state.keywords, [payload.keyword]: { ...state.keywords[payload.keyword], ...payload }}),
  removeKeyword: (state, keyword) => {
    delete state.keywords[keyword];
    delete state.results[keyword];
  },
  updateResults: (state, result) => (state.results = {...state.results, ...result}),
  updateAdditionalResults: (state, result) => (state.additionalResults = {...state.additionalResults, ...result}),
}